<template>
    <div class="customContainer">
        <div class="members-member">
            <div class="members-member__card">
                <p class="members-member__logo" v-if="!dispDashboard"><img src="@/assets/img/main/members_member_img_01.png" alt=""></p>
                <!-- <div class="row">
                    <div class="col-4"> -->
                        <p class="members-member__qr text-center" @click="reflesh()" v-if="(typeof memberData === 'object')">
                            <vue-qrcode v-if="memberData.barcode_param" :value="barcode_param" :options="qr_option" tag="img"></vue-qrcode>
                        </p>
                    <!-- </div>
                    <div class="col-8"> -->
                        <ul class="members-member__infolist" v-if="(typeof memberData === 'object')">
                            <li class="d-flex align-items-center"><span class="members-member__item" style="font-size:50%;">number</span><span class="members-member__name">{{ memberData.number }}</span></li>
                            <li class="d-flex align-items-center"><span class="members-member__item" style="font-size:50%;">name</span>
                                <span class="members-member__name" v-if="memberData.name_title=='様'">
                                    {{ memberData.name_1}} {{ memberData.name_2}} {{ memberData.name_3}} {{ memberData.name_title }}
                                </span>
                                <span class="members-member__name" v-else-if="memberData.name_title=='Mr.'">
                                    {{ memberData.name_title }} {{ memberData.name_3}} {{ memberData.name_2}} {{ memberData.name_1}}
                                </span>
                                <span class="members-member__name" v-else-if="memberData.name_title=='Ms.'">
                                    {{ memberData.name_title }} {{ memberData.name_3}} {{ memberData.name_2}} {{ memberData.name_1}}
                                </span>
                                <span class="members-member__name" v-else-if="memberData.name_title=='Mrs.'">
                                    {{ memberData.name_title }} {{ memberData.name_3}} {{ memberData.name_2}} {{ memberData.name_1}}
                                </span>
                                <span class="members-member__name" v-else>
                                    {{ memberData.name_1}} {{ memberData.name_2}} {{ memberData.name_3}} {{ memberData.name_title }}
                                </span>
                            </li>
                            <li class="d-flex align-items-center"><span class="members-member__item" style="font-size:50%;">membership</span><span class="members-member__name">{{ word_chg(memberData.kbn_label) }}</span></li>
                        </ul>
                    <!-- </div>
                </div> -->
            </div>
            <div class="row mb-2" v-if="btnView">
                <p class="top__cardShow"><a class="button01" href="#" @click="handleClick('close')">{{ word_chg('閉じる') }}</a></p>
            </div>
        </div>
    </div>
</template>
<style>
</style>
<script>
import VueQrcode from "@chenfengyuan/vue-qrcode";
// import informationList from './Information/ListView.vue'
// import driveReservedList from './Drive/ListReservedView.vue'
// import lodgingReservedList from './Lodging/ListReservedView.vue'
// import otherReservedList from './Other/ListReservedView.vue'
// import indexCalendarView from './Reservation/IndexCalendarView.vue'

export default {
    name: 'BsUserCardView',
    data: function () {
        return {
            // 'tab_active': 'drive',//or th ead
            // 'tab_active2': 'drive',//or th ead
            member_code_sw: false,
        }
    },
    props: {
        memberData: {
            type: Object,
            default: () => {}
        },
        displayClass: {
            type: String,
            default: 'col-md-9 ms-sm-auto col-lg-10 px-md-4'
        },
        codeSw: {
            type: Boolean,
            default: true
        },
        dispDashboard: {
            type: Boolean,
            default: false
        },
        btnView: {
            type: Boolean,
            default: true
        }
    },
    created(){
        
    },
    mounted(){
        if(this.codeSw){
            this.member_code_sw = true;
        }

        // if(this.memberData !== 'object'){
        //     this.$router.push({ path: '/logout' });
        // }
    },
    components: {
        VueQrcode,
    },
    methods: {
        handleClick(ev) {
        this.$emit('to_click_event', ev)
        },
        reflesh() {
        this.$emit('to_click_reflesh')
        }
    },
    computed: {
        barcode_param: function(){
            const param = {
                code: this.memberData.barcode_param,
                no: 0
            }
            return JSON.stringify(param);
        },
        qr_option: function(){
            const options = {};
            options['color'] = {
                dark: '#696969',
                light: '#FFFFFF'
            }
            if(this.memberData && this.memberData.checkin && typeof this.memberData.checkin === 'object'){
                options['color']['dark'] = '#c80014';
            }
            return options;
        }
    }
}
</script>
